import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { saveUserInput } from 'libs/localApi'
import useContent from 'store/content'

// assure que ca roule juste on mount/on page load
// will always overright the value in sotre on page load
const InputGetParameter = ({ input }) => {
  const router = useRouter()
  const value = router.query[input.name]
  const content = useContent()
  const appId = content.get.appId()

  const saveValue = () => {
    if (value) {
      saveUserInput(appId, input.name, value)
    }
  }

  useEffect(saveValue, [])
  useEffect(saveValue, [value])

  return null
}

InputGetParameter.propTypes = { input: PropTypes.any }

export default InputGetParameter
